import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'splitText',
    standalone: true,
})
export class SplitTextPipe implements PipeTransform {
	transform(value: string | undefined, separator = '.'): string[] | undefined {
		return value ? value.split(separator) : [];
	}
}
